export enum Styles {
  Dropdown = 'dropdown',
  Button = 'button',
}
